import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
export function HeroSection() {
  return <div className="relative bg-brand-light overflow-hidden min-h-[85vh] flex items-center" data-id="element-106">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-brand-navy hidden lg:block" style={{
      clipPath: 'polygon(20% 0, 100% 0, 100% 100%, 0% 100%)'
    }} data-id="element-107"></div>
      <div className="absolute top-0 right-0 w-full lg:w-1/2 h-full opacity-10 lg:opacity-20" style={{
      backgroundImage: 'radial-gradient(#F59E0B 2px, transparent 2px)',
      backgroundSize: '40px 40px'
    }} data-id="element-108"></div>

      {/* Amber Accent Shapes */}
      <motion.div initial={{
      scale: 0,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="absolute top-20 right-20 w-64 h-64 bg-brand-amber rounded-full mix-blend-multiply filter blur-3xl opacity-50 hidden lg:block" data-id="element-109"></motion.div>
      <motion.div initial={{
      scale: 0,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 0.8,
      delay: 0.4
    }} className="absolute bottom-20 right-1/3 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-30 hidden lg:block" data-id="element-110"></motion.div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full flex flex-col lg:flex-row items-center" data-id="element-111">
        {/* Left Content */}
        <div className="w-full lg:w-3/5 pr-0 lg:pr-12 py-20" data-id="element-112">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-113">
            <div className="inline-flex items-center space-x-2 bg-white px-4 py-2 rounded-full mb-8 shadow-sm border border-gray-100" data-id="element-114">
              <span className="w-2 h-2 rounded-full bg-brand-amber animate-pulse" data-id="element-115"></span>
              <span className="text-brand-navy text-sm font-bold uppercase tracking-wider" data-id="element-116">
                Trusted Temporary HVAC Solutions
              </span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-extrabold text-brand-navy leading-[1.1] mb-6" data-id="element-117">
              Temporary Heating & Cooling Solutions{' '}
              <br className="hidden md:block" data-id="element-118" />
              <span className="text-brand-amber" data-id="element-119">You Can Rely On.</span>
            </h1>

            <p className="text-lg md:text-xl text-brand-slate mb-10 max-w-2xl leading-relaxed" data-id="element-120">
              We maintain a modern fleet of high-efficiency equipment,
              engineered for maximum performance. Delivered and commissioned
              nationwide, 24/7.
            </p>

            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-121">
              <Link to="/services" className="inline-flex justify-center items-center px-8 py-4 bg-brand-amber text-white font-bold rounded hover:bg-brand-navy transition-colors duration-300 group" data-id="element-122">
                Explore Services
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-123" />
              </Link>
              <a href="tel:08004647025" className="inline-flex justify-center items-center px-8 py-4 bg-white border-2 border-brand-navy text-brand-navy font-bold rounded hover:bg-brand-navy hover:text-white transition-colors duration-300" data-id="element-124">
                <Phone className="mr-2 w-5 h-5" data-id="element-125" />
                Call Us Now
              </a>
            </div>
          </motion.div>
        </div>

        {/* Right Content - Animated Counter Panel */}
        <div className="w-full lg:w-2/5 mt-12 lg:mt-0" data-id="element-126">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-white p-8 md:p-10 rounded-2xl shadow-2xl border border-gray-100 relative overflow-hidden" data-id="element-127">
            <div className="absolute top-0 left-0 w-2 h-full bg-brand-amber" data-id="element-128"></div>
            <h3 className="text-2xl font-heading font-bold text-brand-navy mb-8" data-id="element-129">
              Rapid Deployment Stats
            </h3>

            <div className="space-y-8" data-id="element-130">
              <div data-id="element-131">
                <div className="flex justify-between items-end mb-2" data-id="element-132">
                  <span className="text-brand-slate font-medium" data-id="element-133">
                    Emergency Response
                  </span>
                  <span className="text-3xl font-heading font-bold text-brand-navy" data-id="element-134">
                    &lt;24<span className="text-lg text-brand-amber" data-id="element-135">hr</span>
                  </span>
                </div>
                <div className="w-full bg-gray-100 h-2 rounded-full overflow-hidden" data-id="element-136">
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: '100%'
                }} transition={{
                  duration: 1,
                  delay: 0.5
                }} className="bg-brand-amber h-full" data-id="element-137"></motion.div>
                </div>
              </div>

              <div data-id="element-138">
                <div className="flex justify-between items-end mb-2" data-id="element-139">
                  <span className="text-brand-slate font-medium" data-id="element-140">
                    UK Coverage
                  </span>
                  <span className="text-3xl font-heading font-bold text-brand-navy" data-id="element-141">
                    100<span className="text-lg text-brand-amber" data-id="element-142">%</span>
                  </span>
                </div>
                <div className="w-full bg-gray-100 h-2 rounded-full overflow-hidden" data-id="element-143">
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: '100%'
                }} transition={{
                  duration: 1,
                  delay: 0.7
                }} className="bg-brand-navy h-full" data-id="element-144"></motion.div>
                </div>
              </div>

              <div data-id="element-145">
                <div className="flex justify-between items-end mb-2" data-id="element-146">
                  <span className="text-brand-slate font-medium" data-id="element-147">
                    Availability
                  </span>
                  <span className="text-3xl font-heading font-bold text-brand-navy" data-id="element-148">
                    24/7
                  </span>
                </div>
                <div className="w-full bg-gray-100 h-2 rounded-full overflow-hidden" data-id="element-149">
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: '100%'
                }} transition={{
                  duration: 1,
                  delay: 0.9
                }} className="bg-brand-amber h-full" data-id="element-150"></motion.div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}